import { createRouter, createWebHistory } from "vue-router"
import { useAuthentication } from "@/composables/useAuthentication"
import { loadTranslations } from "@/locales"
import privateRoutes from "./privateRoutes"
import publicRoutes from "./publicRoutes"
import { useUserStore } from "@/stores/user"
import { useUserAccountsStore } from "@/stores/userAccounts"

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [...publicRoutes, ...privateRoutes, { path: "/:pathMatch(.*)*", redirect: "/login" }]
})

router.beforeEach(async (to, from, next) => {
  const { userIsAuthenticated, logout } = useAuthentication()
  const _hasValidToken = await userIsAuthenticated()
  const userStore = useUserStore()
  const userAccountsStore = useUserAccountsStore()

  await loadTranslations({ forceLoadFromBackend: to.meta.forceLoadTranslationsFromBackend })

  try {
    // Si el usuario tiene un token válido y la ruta no requiere autenticación, redirige al home
    if (_hasValidToken && !to.meta.requiresAuth) {
      return next({ name: "home" })
    }

    // Si la ruta requiere autenticación, procede con la verificación normal
    if (to.meta.requiresAuth) {
      if (_hasValidToken) {
        if (!userStore.user) {
          await Promise.all([userStore.loadUser(), userAccountsStore.init(from.query.invite_id)])
        }
        return next()
      } else {
        throw new Error("User is not auth")
      }
    }

    // Si la ruta es pública y no tiene un token válido, permite el acceso
    next()
  } catch (error) {
    console.error(error)
    next({ name: "login" })
    logout()
  }
})

export default router
